export default __webpack_public_path__ + "static/media/cs-c001-Picture3.24a7b888.png";